import { Component, ElementRef,OnInit } from '@angular/core';
import { WindowRef } from 'src/windowRef.server';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  menuB = true;
  constructor(private windowRef: WindowRef,private el: ElementRef) { }

  ngOnInit(): void {
      this.windowRef.nativeWindow.addEventListener('resize', () => {
        if (this.windowRef.nativeWindow.innerWidth > 767.98 ) {
          const menu = document.getElementById('menu');
          menu.style.height = '';
        }
      });
  }
  backToTop() {
    this.windowRef.nativeWindow.scroll(0, 0);
  }
  navbtn() {
    const menu = this.el.nativeElement.querySelector('#menu');
    const nbs1 = this.el.nativeElement.querySelector('#nbs1');
    const nbs2 = this.el.nativeElement.querySelector('#nbs2');
    if (this.menuB === true) {
      menu.style.height = '315px';
      nbs1.style.transform = 'translate(-5px, -8px)';
      nbs2.style.transform = 'translate(5px, 8px)';
      this.menuB = false;
    } else {
      menu.style.height = '0px';
      nbs1.style.transform = 'translate(0, -8px)';
      nbs2.style.transform = 'translate(0, 8px)';
      this.menuB = true;
    }
  }
  navbtnR() {
    const bw = this.windowRef.nativeWindow.innerWidth;
    const nb = this.el.nativeElement.querySelector('#nav-btn');
    if ( bw <  767.98) {
      nb.click();
    }
  }
}
